import styles from "../styles/FilterComponents.module.scss";
import { useTranslation } from "react-i18next";
import { QuickFilter } from "../../../store/slices/filters.slice";

const QUICK_FILTERS: { key: QuickFilter; label: string }[] = [
  { key: "for_you", label: "quickFilter_for_you" },
  { key: "popular", label: "quickFilter_popular" },
  { key: "top_rated", label: "quickFilter_top_rated" },
  { key: "new_releases", label: "quickFilter_new_releases" },
];

interface IProps {
  activeFilter: QuickFilter;
  onSelect: (filter: QuickFilter) => void;
}

const FilterBar = ({ activeFilter, onSelect }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.filterBarWrapper}>
      <div className={styles.filterBarChips}>
        {QUICK_FILTERS.map((item) => (
          <div
            key={item.key}
            onClick={() => onSelect(item.key)}
            className={`${styles.filterBarChip} ${
              activeFilter === item.key ? styles.filterBarChipActive : ""
            }`}
          >
            {t(item.label)}
          </div>
        ))}
      </div>
      <div className={styles.filterBarSeparator} />
    </div>
  );
};

export default FilterBar;
